// import axios from "axios";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// // Action Types
// export const FETCH_GEOFENCE_REQUEST = "FETCH_GEOFENCE_REQUEST";
// export const FETCH_GEOFENCE_SUCCESS = "FETCH_GEOFENCE_SUCCESS";
// export const FETCH_GEOFENCE_FAILURE = "FETCH_GEOFENCE_FAILURE";

// export const DELETE_GEOFENCE_REQUEST = "DELETE_GEOFENCE_REQUEST";
// export const DELETE_GEOFENCE_SUCCESS = "DELETE_GEOFENCE_SUCCESS";
// export const DELETE_GEOFENCE_FAILURE = "DELETE_GEOFENCE_FAILURE";


// // Fetch Park Geofence with pagination + filters
// export const fetchParkGeofenceDetails = (
//   page = 1,
//   limit = 10,
//   districtId = "",
//   municipalityId = ""
// ) => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_GEOFENCE_REQUEST });
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.get(
//         `${BASE_URL}/v1/api/parkGeofenceDetails?page=${page}&limit=${limit}&districtId=${districtId}&municipalityId=${municipalityId}`,
//         {
//           headers: { authorization: token },
//         }
//       );

//       dispatch({
//         type: FETCH_GEOFENCE_SUCCESS,
//         payload: {
//           list: response.data.data,
//           pagination: response.data.pagination,
//         },
//       });

//     } catch (error) {
//       dispatch({
//         type: FETCH_GEOFENCE_FAILURE,
//         payload: error.response?.data?.meta?.message || error.message,
//       });
//     }
//   };
// };

// // Delete a Park Geofence by ID
// export const deleteParkGeofence = (id) => {
//   return async (dispatch) => {
//     dispatch({ type: DELETE_GEOFENCE_REQUEST });
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.delete(
//         `${BASE_URL}/v1/api/park-geofence/${id}`,
//         {
//           headers: { authorization: token },
//         }
//       );

//       dispatch({
//         type: DELETE_GEOFENCE_SUCCESS,
//         payload: response.data.data, // expected { id: 2 }
//       });

//       return response.data;
//     } catch (error) {
//       dispatch({
//         type: DELETE_GEOFENCE_FAILURE,
//         payload: error.response?.data?.meta?.message || error.message,
//       });
//       throw error;
//     }
//   };
// };

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_GEOFENCE_REQUEST = "FETCH_GEOFENCE_REQUEST";
export const FETCH_GEOFENCE_SUCCESS = "FETCH_GEOFENCE_SUCCESS";
export const FETCH_GEOFENCE_FAILURE = "FETCH_GEOFENCE_FAILURE";

export const DELETE_GEOFENCE_REQUEST = "DELETE_GEOFENCE_REQUEST";
export const DELETE_GEOFENCE_SUCCESS = "DELETE_GEOFENCE_SUCCESS";
export const DELETE_GEOFENCE_FAILURE = "DELETE_GEOFENCE_FAILURE";

// Fetch Park Geofence with pagination + filters (updated with search and project_type)
export const fetchParkGeofenceDetails = (
  page = 1,
  limit = 10,
  districtId = "",
  municipalityId = "",
  search = "",          // NEW: Combined search for project_code and park_name
  projectType = ""      // NEW: Filter by project type
) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_GEOFENCE_REQUEST });
    const token = localStorage.getItem("token");

    try {
      // Build URL with all parameters
      let url = `${BASE_URL}/v1/api/parkGeofenceDetails?page=${page}&limit=${limit}`;
      
      if (districtId) {
        url += `&districtId=${districtId}`;
      }
      
      if (municipalityId) {
        url += `&municipalityId=${municipalityId}`;
      }
      
      // NEW: Add search parameter if provided
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      // NEW: Add project type filter if provided
      if (projectType) {
        url += `&project_type=${encodeURIComponent(projectType)}`;
      }

      const response = await axios.get(url, {
        headers: { authorization: token },
      });

      dispatch({
        type: FETCH_GEOFENCE_SUCCESS,
        payload: {
          list: response.data.data,
          pagination: response.data.pagination,
        },
      });

    } catch (error) {
      dispatch({
        type: FETCH_GEOFENCE_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
    }
  };
};

// Delete a Park Geofence by ID
export const deleteParkGeofence = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_GEOFENCE_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(
        `${BASE_URL}/v1/api/park-geofence/${id}`,
        {
          headers: { authorization: token },
        }
      );

      dispatch({
        type: DELETE_GEOFENCE_SUCCESS,
        payload: response.data.data, // expected { id: 2 }
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: DELETE_GEOFENCE_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      throw error;
    }
  };
};